import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Divider, Form, Input } from 'antd';
import { ReactComponent as CoronaSvg } from '../../../assets/icons/corona.svg';
import { ReactComponent as BrainSvg } from '../../../assets/icons/brain.svg';
import { ReactComponent as MaternalSvg } from '../../../assets/icons/maternal.svg';
import { ReactComponent as NutritionSvg } from '../../../assets/icons/nutrition.svg';
import { ReactComponent as HourGlassSvg } from '../../../assets/icons/knowledge-bank/hourglass.svg';

const { Search } = Input;
const { Title, Paragraph } = Typography;

const data = [
  {name: 'Covid', icon: <CoronaSvg />, url: '/knowledge-bank/detail'},
  {name: 'Nutrition', icon: <NutritionSvg />, url: '/knowledge-bank/detail'},
  {name: 'Maternal & Child', icon: <MaternalSvg />, url: '/knowledge-bank/detail'},
  {name: 'Mental Health', icon: <BrainSvg />, url: '/knowledge-bank/detail'},
];

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
}

const styles = {
  title: {
    color: '#404047',
    fontWeight: '500',
    fontSize: '24px',
    textAlign: 'center',
    margin: 0,
    marginBottom: 5
  },
  subtitle: {
    color: '#15A9E1',
    fontSize: 14,
    lineHeight: '19px',
    textAlign: 'center',
    fontWeight: '300'
  },
  itemTitle: {
    fontSize: 14,
    lineHeight: '17px',
    textAlign: 'center',
    fontWeight: '400',
    color: '#404047',
    marginBottom: 0
  },
  box: {
    background: '#FFFFFF',
    border: '1px solid #F4F4F4',
    borderRadius: 5,
    marginRight: 12,
    marginBottom: 12,
    minHeight: 150
  },
  circle: {
    width: 100,
    height: 100,
    backgroundColor: '#E7E7E7',
    borderRadius: '50%',
    margin: '0 auto',
    marginBottom: 15
  },
  boxComingSoon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "#F2FBFF",
    border: "1px solid #15A9E1",
    boxShadow: "0px 0px 15px rgba(21, 169, 225, 0.25)",
    borderRadius: "5px",
    padding: "40px 26px 60px"
  },
  comingSoonTitle: {
    fontWeight: "500",
    fontSize: "30px",
    lineHeight: "37px",
    textAlign: "center",
    color: "#15A9E1",
    marginTop: 30,
    marginBottom: 25
  },
  comingSoonDesc: {
    fontWeight: "400",
    fontSize: "15px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#8C8C8C",
    marginBottom: 15
  },
  line: {
    width: 33,
    marginLeft: "auto",
    marginRight: "auto",
    border: "2px solid #15A9E1",
    marginBottom: 25
  }
};

function MobileKnowledgeBankScreen() {
  const { t } = useTranslation(['knowledge-bank', 'common']);
  const history = useHistory();

  const renderAvatar = (item) => {
    return (
      <Col xs={12}>
        <Box paddingY={12} paddingX={18} style={styles.box} onClick={() => history.push(item.url)}>
          {
            item.icon !== null
            ? (
              <Box textAlign="center" style={{ marginBottom: 15 }}>
                {item.icon}
              </Box>
            )
            : (
              <Box style={styles.circle} />
            )
          }
          <Title level={4} style={styles.itemTitle}>
            {item.name}
          </Title>
        </Box>
      </Col>
    )
  }

  return (
    <>
      <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
        <Col>
          <Title level={4} style={styles.title}>
            {t('knowledge-bank:home.title')}
          </Title>
          {/* <p style={styles.subtitle}>
            {t('knowledge-bank:home.subtitle')}
          </p> */ }
        </Col>
      </Row>
      <Box style={styles.boxComingSoon}>
        <HourGlassSvg />
        <Title level={4} style={styles.comingSoonTitle}>
          {t('knowledge-bank:comingSoon.title')}
        </Title>
        <Box style={styles.line} />
        <Paragraph style={styles.comingSoonDesc}>
          {t('knowledge-bank:comingSoon.desc1')}
        </Paragraph>
        <Paragraph>
          {t('knowledge-bank:comingSoon.desc2')}
        </Paragraph>
      </Box>
      {/* <Divider />
      <Box marginTop={26}>
        <Form.Item
          style={{ width: '100%', padding: '3%' }}
          formItemLayout={formItemLayout}
        >
          <Search placeholder={t('knowledge-bank:search')} />
        </Form.Item>
      </Box>
      <Row>
        {data.map((item) => renderAvatar(item))}
      </Row> */ }
    </>
  );
}

export default MobileKnowledgeBankScreen;
